<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-pac"
  [title]="
    (actionStack!.getValue('paPModeRegulation') === 0
      ? 'P00043.dashboard.card.title.warm'
      : 'P00043.dashboard.card.title.cold'
    ) | translate
  "
  [content]="buttons[this.actionStack!.getValue('paCModeFonctionnement')].icon!"
  [color]="buttons[this.actionStack!.getValue('paCModeFonctionnement')].color!"
  [status]="
    buttonMode[this.actionStack!.getValue('paSCommande')].title! | translate
  "
  [mode]="getTemperature(actionStack!.getValue('paPConsigneTemperature'), 0)"
  [statusMode]="buttonMode[this.actionStack!.getValue('paSCommande')].status!"
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
